import React from 'react';

const Escala = ({preguntaId, onChange, respuestaSeleccionada}) => {

    const handleChange = (e) => {
        onChange(preguntaId, e.target.value); 
    };

    return (
        <React.Fragment>
            <div className='flex flex-row items-center space-x-2 bg-white p-2 rounded-md sm:w-full md:w-auto max-w-max'>
                <p className='text-md font-bold sm:ml-0 md:ml-5'>Baixa</p>
                {/* Map para generar los números del 1 al 10 */}
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                    <div key={`escala-${preguntaId}-${num}`} className='w-4 md:w-12'>
                        <input 
                            type="radio" 
                            name={`escala-${preguntaId}`} 
                            id={`radio-${preguntaId}-${num}`}
                            value={num} 
                            checked={respuestaSeleccionada == num}
                            className="peer hidden" 
                            onChange={handleChange} 
                            required
                        />
                        <label 
                            htmlFor={`radio-${preguntaId}-${num}`} 
                            className="block cursor-pointer select-none rounded-full p-0 text-center peer-checked:bg-customRed peer-checked:font-bold peer-checked:text-white"
                        >
                            {num}
                        </label>
                    </div>
                    ))}
                <p className='text-md font-bold sm:pr-0 md:pr-5'>Alta</p>
            </div>
        </React.Fragment>
    );
}

export default Escala;